import {ModelTypes} from '@catcore/utils/json-schema';
import {ProjectParametersLandingComponent} from '@catdetails/components/landing-pages/project-parameters-landing/project-parameters-landing.component';
import {ProjectUnitsLandingComponent} from '@catdetails/components/landing-pages/project-units-landing/project-units-landing.component';

const componentMap = new Map();
componentMap.set(ModelTypes.ProjectUnit, ProjectUnitsLandingComponent);
componentMap.set(ModelTypes.ProjectParameter, ProjectParametersLandingComponent);

export const modelFormsForWizard = componentMap;



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/shared/model-forms-for-wizard.map.ts